"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginationDefaultProps = exports.defaultGetSelectedPageHiddenText = exports.OUTLINE_WIDTH = exports.OUTLINE_OFFSET = exports.DOTTED_PAGE_BUTTON_SIZE = exports.CONFIGURATION_SMALL = exports.CONFIGURATION_DEFAULT = exports.BUTTON_SIZE_SMALL = exports.BUTTON_SIZE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utils = require("../utils");

var _interfaces = require("./interfaces");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var defaultButtonAriaLabelGenerator = function defaultButtonAriaLabelGenerator(_ref) {
  var isNextButton = _ref.isNextButton,
      isPreviousButton = _ref.isPreviousButton,
      pageNumber = _ref.pageNumber,
      isFirstPage = _ref.isFirstPage,
      isLastPage = _ref.isLastPage;

  if (isNextButton) {
    return 'Next page';
  }

  if (isPreviousButton) {
    return 'Previous page';
  }

  var suffix = isFirstPage ? ' First page' : isLastPage ? ' Last page' : '';
  return "Page ".concat(pageNumber, ".").concat(suffix);
};

var paginationDefaultProps = {
  'aria-label': 'Page selection',
  generateButtonAriaLabel: defaultButtonAriaLabelGenerator,
  variant: _interfaces.PaginationVariant.Default
};
exports.paginationDefaultProps = paginationDefaultProps;

var defaultGetSelectedPageHiddenText = function defaultGetSelectedPageHiddenText(selectedPage) {
  return "Current page ".concat(selectedPage);
};

exports.defaultGetSelectedPageHiddenText = defaultGetSelectedPageHiddenText;
var CONFIGURATION_DEFAULT = {
  // The maximum number of pages which are allowed to be displayed without using ellipses.
  showAllPagesThreshold: 7,
  // The maximum number of pages which can be displayed at the start or end of the list.
  maxPagesAtEnds: 5,
  // The maximum number of pages which can be displayed in the middle of the list.
  maxPagesInCenter: 3
};
exports.CONFIGURATION_DEFAULT = CONFIGURATION_DEFAULT;

var CONFIGURATION_SMALL = _objectSpread(_objectSpread({}, CONFIGURATION_DEFAULT), {}, {
  showAllPagesThreshold: 5,
  maxPagesAtEnds: 3,
  maxPagesInCenter: 1
});

exports.CONFIGURATION_SMALL = CONFIGURATION_SMALL;
var BUTTON_SIZE = Math.max(40, _utils.A11Y_MIN_SIZE);
exports.BUTTON_SIZE = BUTTON_SIZE;
var BUTTON_SIZE_SMALL = Math.max(32, _utils.A11Y_MIN_SIZE);
exports.BUTTON_SIZE_SMALL = BUTTON_SIZE_SMALL;
var OUTLINE_WIDTH = 2;
exports.OUTLINE_WIDTH = OUTLINE_WIDTH;
var OUTLINE_OFFSET = 2;
exports.OUTLINE_OFFSET = OUTLINE_OFFSET;
var DOTTED_PAGE_BUTTON_SIZE = Math.max(24, _utils.A11Y_MIN_SIZE_2_5_8);
exports.DOTTED_PAGE_BUTTON_SIZE = DOTTED_PAGE_BUTTON_SIZE;